export const getHandRaisedAlertId = (sessionId: string) => `hand-raised.${sessionId}`;

// Re-export component exports from the .tsx file so that imports resolving to this
// .ts module (which takes priority over .tsx in TypeScript's resolution) still work.
export { default } from './promotions.tsx';
